import { environment } from '@portal/env';
import { AuthServiceStorageKeys, POST_LOGIN_ROUTE_KEY } from './auth.service';
import {
  PassedInitialConfig,
  StsConfigLoader,
  OpenIdConfiguration,
  LogLevel,
  StsConfigStaticLoader
} from 'angular-auth-oidc-client';

const getRealmId = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(AuthServiceStorageKeys.TenantId) ?? environment.keycloak.realm;
};

const getPostLoginRoute = (): string => {
  const postLoginRoute = localStorage.getItem(POST_LOGIN_ROUTE_KEY);

  return postLoginRoute || window.location.origin;
};

export const authConfig: PassedInitialConfig = {
  loader: {
    provide: StsConfigLoader,
    useFactory: () => {
      const updatedConfig: OpenIdConfiguration = {
        authority: `${environment.keycloak.url}/realms/${getRealmId()}`,
        unauthorizedRoute: '/unauthorized',
        postLoginRoute: getPostLoginRoute(),
        redirectUrl: window.location.origin + '/callback',
        postLogoutRedirectUri: window.location.origin,
        clientId: environment.keycloak.clientId,
        scope: 'openid',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        logLevel: LogLevel.Debug,
        //ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
        //triggerRefreshWhenIdTokenExpired: false,
        // allowUnsafeReuseRefreshToken: true, // this is required if the refresh token is not rotated
        autoUserInfo: false // if the user endpoint is not supported
      };
      return new StsConfigStaticLoader(updatedConfig);
    }
  }
};
